const esMX= {
    login: {
      title: 'Iniciar sesión',
      sign_in_btn: 'Iniciar sesión'
    },
    bar: {
        logout: 'Cerrar sesión',
        languages: 'Idiomas',
        settings: 'Abrir la configuración'
    },
    language: {
      name: 'Español (México)',
    },
    attributePage: {
        title: 'Cambios en los atributos',
        viewChanges: 'Ver los cambios',
        dateTime: 'Fecha',
        notificationType: 'Tipo de notificación',
        notificationValue: 'Valor de la notificación',
        oldValue: 'Valor antiguo',
        newValue: 'Nuevo valor',
        accept: 'Aceptar',
        reject: 'Rechazar',
    },
    Home: 'Inicio',
    load: 'Realizando la carga inicial...',
    Requested: "Solicitado",
    Viewed: "Visto",
    Executing: "Ejecuctando",
    Completed: "Finalizado",
    Expired: "Expirado",
    Cancelled: "Cancelado",
    Error: "Error",
    Rejected: "Rechazado",
    error: 'Algo salió mal; inténtelo de nuevo más tarde.',
    displayname: 'Nombre para mostrar',
    givenname: 'Nombre',
    surname: 'Apellido',
    email: 'Correo electrónico',
    mail: 'Correo electrónico',
    name: 'Nombre',
    firstname: 'Nombre',
    lastname: 'Apellido',
    footer_copyright: 'Todos los derechos reservados.'
  };
  
  export default esMX;
  